import BulkOperationsController from './BulkOperationsController'
import {arrayToMap} from '../../../atUtils'

export default class BulkChangeStatusTasksController extends BulkOperationsController {
    constructor({
        method,
        onSuccess = () => {},
        onProgress = () => {},
        onFailure = () => {},
    }) {
        super({
            method,
            initialResult: {
                taskIds: [],
                restoredProjects: {},
                restoredCustomers: {},
            },
            combineFn: (result, chunkResult) => {
                return {
                    taskIds: [...result.taskIds, ...chunkResult.taskIds],
                    restoredProjects: {
                        ...result.restoredProjects,
                        ...arrayToMap(chunkResult.restoredProjects),
                    },
                    restoredCustomers: {
                        ...result.restoredCustomers,
                        ...arrayToMap(chunkResult.restoredCustomers),
                    },
                }
            },
            onSuccess,
            onProgress,
            onFailure,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/controller/BulkChangeStatusTasksController.js